module.exports = __webpack_public_path__ + "8ca375165a44ded899a24fa3264636fe.svg";